// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vant from 'vant'
import router from './router'
import 'lib-flexible/flexible'
import './common/font.css';
import 'vant/lib/index.css';
import api from './api/index'
// import  Axios from 'axios'
import { post, get ,getBaseUrl } from './request/request'
import store from "./store";


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.use(Vant);
import './icons'
Vue.config.productionTip = false
Vue.prototype.API1url = api
// Vue.prototype.axios = Axios
//封装axios

//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$getBaseUrl = getBaseUrl;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js